/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IHosportsZendeskData } from './hosports-zendesk.data';
import { IHosportsZendeskProps } from './hosports-zendesk.props.autogenerated';

export interface IHosportsZendeskViewProps extends IHosportsZendeskProps<IHosportsZendeskData> {

}

/**
 *
 * HosportsZendesk component
 * @extends {React.PureComponent<IHosportsZendeskProps<IHosportsZendeskData>>}
 */
class HosportsZendesk extends React.PureComponent<IHosportsZendeskProps<IHosportsZendeskData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default HosportsZendesk;
